import React, { useEffect } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import { useQuery } from "@apollo/client";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import {
  QUERY_ALL_USER,
  QUERY_CSO_COLLABORATION_NEEDS,
  QUERY_CSO_COLLABORATION_POLICY,
  QUERY_GET_ALL_ACTIVITY,
  QUERY_SUPPORTER_INFORMATION,
} from "../../../../queries";
import { sendGAEvent } from "../../../../utils";

const TabCollaborationPolicy = (props) => {
  const { activeKey } = props;
  const collaborationNeeds = useQuery(QUERY_CSO_COLLABORATION_NEEDS);
  const supporterInformation = useQuery(QUERY_SUPPORTER_INFORMATION);
  const csoCollaborationPolicy = useQuery(QUERY_CSO_COLLABORATION_POLICY);
  const allActivity = useQuery(QUERY_GET_ALL_ACTIVITY);
  const user = useQuery(QUERY_ALL_USER, {
    variables: { email: useUserEmail() },
  });

  const editBtnStyle = {
    border: "1px solid #44CAE1",
    borderRadius: "50px",
    padding: "7px 11px",
    width: "130px",
    backgroundColor: "transparent",
    textAlign: "center",
    color: "#44CAE1",
  };

  useEffect(() => {
    localStorage.setItem("tabActive", activeKey);
    sendGAEvent(
      "pageview",
      "/#/dashboards/organization-partnership/collaboration_policy_tab"
    );
  }, [activeKey]);

  useEffect(() => {
    if (!csoCollaborationPolicy?.data) return;
    if (!supporterInformation?.data) return;
    if (!allActivity?.data) return;
    console.log({
      csoCollaborationPolicy: csoCollaborationPolicy?.data,
      supporterInformation: supporterInformation?.data,
      allActivity: allActivity?.data,
    });
  }, [csoCollaborationPolicy, supporterInformation, allActivity]);

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      {supporterInformation?.loading ||
      user?.loading ||
      allActivity?.loading ? (
        <div className="loading__wrapper">
          <img style={{ width: "80px", margin: "auto" }} src={animetionLogo} />
        </div>
      ) : null}

      {!supporterInformation?.loading &&
        !supporterInformation.error &&
        !user?.loading &&
        !user.error &&
        user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
          <Row>
            <Col md="12">
              <div
                className="d-flex flex-column"
                style={{ marginTop: "28px", gap: "34px" }}
              >
                <div className="d-flex ema__flex_end">
                  <a
                    href="/#/dashboards/plofile-organization"
                    target="_blank"
                    className="button-redirect-smartphone"
                    style={editBtnStyle}
                    onClick={() => {
                      localStorage.setItem("tab", "2");
                    }}
                  >
                    編集はこちら
                  </a>
                </div>
                <div
                  style={{
                    marginTop: "-36px",
                    marginBottom: "-16px",
                  }}
                >
                  自組織の方針について可能な範囲で記載や項目を選択してみましょう。ここで記載した内容は、メッセージを送ったCSO
                  にのみ以下を含む組織情報が閲覧可能となります。これにより、双方の連携の目的や目指す価値のマッチ度が高まります
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <p
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "14px" }}
                  >
                    ミッション
                  </p>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px" }}
                  >
                    {
                      supporterInformation?.data?.allSupporters?.edges[0]?.node
                        ?.mission
                    }
                  </p>
                </div>
                {user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
                  <div className="d-flex flex-column" style={{ gap: "8px" }}>
                    <p
                      className="mb-0 font-weight-bold"
                      style={{ fontSize: "14px" }}
                    >
                      サスティナビリティ/CSR方針
                    </p>
                    <p
                      className="mb-0 font-weight-normal"
                      style={{ fontSize: "13px" }}
                    >
                      {
                        supporterInformation?.data?.allSupporters?.edges[0]
                          ?.node?.sustainabilityPolicy
                      }
                    </p>
                  </div>
                )}
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <p
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "14px" }}
                  >
                    解決したい社会課題について教えてください
                  </p>
                  <Row>
                    <Col xs="12" md={2}>
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        連携・活動したい国は？
                      </p>
                    </Col>
                    <Col xs="12" md={10}>
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#000000" }}
                      >
                        {supporterInformation?.data?.allSupporters?.edges[0]?.node?.interestingCountry?.edges?.map(
                          (country, index) => {
                            return (
                              <span key={index}>
                                {index === 0
                                  ? country?.node?.nameJp
                                  : `, ${country?.node?.nameJp}`}
                              </span>
                            );
                          }
                        )}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md="2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        注力したい社会課題分野は？
                      </p>
                    </Col>
                    <Col xs="12" md="10">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {allActivity?.data?.allActivityfields?.edges?.map(
                          (issue, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    supporterInformation?.data?.allSupporters?.edges[0]?.node?.interestingActivity?.edges?.find(
                                      (x) => x?.node?.id === issue?.node?.id
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">{issue?.node?.name}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="12" md={2} className="mb-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        対象としたい課題当事者は？
                      </p>
                    </Col>
                    <Col xs="12" md="10">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {supporterInformation?.data?.allTarget?.edges?.map(
                          (target, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    supporterInformation?.data?.allSupporters?.edges[0]?.node?.focusedStakeholders?.edges?.find(
                                      (x) =>
                                        x?.node?.name === target?.node?.name
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">{target?.node?.name}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4 mb-2">
                    <Col xs={12}>
                      <div
                        style={{
                          fontWeight: "700",
                        }}
                      >
                        社会課題への取組・CSOとの連携で自組織が提供できるコトについて教えてください
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        提供できる/したい 価値・アセットは？
                      </p>
                    </Col>
                    <Col xs="12" md="10">
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {supporterInformation?.data?.allCollaborationNeeds?.edges?.map(
                          (collaborationNeed, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    supporterInformation?.data?.allSupporters?.edges[0]?.node?.collaborationNeeds?.edges?.find(
                                      (x) =>
                                        x?.node?.id ===
                                        collaborationNeed?.node?.id
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">
                                  {collaborationNeed?.node?.title}
                                </p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}

      {!supporterInformation?.loading &&
        !supporterInformation.error &&
        !user?.loading &&
        !user.error &&
        !user?.data?.allUsers?.edges[0]?.node?.isSupporter && (
          <Row>
            <Col md="12">
              <div
                className="d-flex flex-column"
                style={{ marginTop: "28px", gap: "16px" }}
              >
                <div className="d-flex ema__flex_end">
                  <a
                    href="/#/dashboards/plofile-organization"
                    className="button-redirect-smartphone"
                    style={editBtnStyle}
                    onClick={() => {
                      localStorage.setItem("tab", "2");
                    }}
                    target="_blank"
                  >
                    編集はこちら
                  </a>
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <p
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "14px" }}
                  >
                    ミッション
                  </p>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px" }}
                  >
                    {
                      csoCollaborationPolicy?.data?.myCso?.edges[0]?.node
                        ?.purpose
                    }
                  </p>
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <p
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "14px" }}
                  >
                    連携を通じて創造したい価値
                  </p>
                  <Row className="mb-2">
                    <Col xs="12" md={2} className="md-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        地域
                      </p>
                    </Col>
                    <Col xs="12" md={10}>
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#000000" }}
                      >
                        {collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.countries?.edges
                          ?.map((country) => {
                            return country?.node?.nameJp;
                          })
                          ?.join(", ")}
                        {/* {csoCollaborationPolicy?.data?.myCso?.edges[0]?.node?.activeCountries?.map(
                          (country, index) => {
                            return (
                              <span key={index}>
                                {index === 0 ? country : `, ${country}`}
                              </span>
                            );
                          }
                        )} */}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        課題分野
                      </p>
                    </Col>
                    <Col xs="12" md={10}>
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {allActivity?.data?.allActivityfields?.edges?.map(
                          (issue, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.activityFields?.edges?.find(
                                      (x) => x?.node?.id === issue?.node?.id
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">{issue?.node?.name}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        連携方法・ニーズ
                      </p>
                    </Col>
                    <Col xs="12" md={10}>
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {supporterInformation?.data?.allCollaborationNeeds?.edges?.map(
                          (collaborationNeed, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    csoCollaborationPolicy?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.collaborationNeeds?.edges?.find(
                                      (x) =>
                                        x?.node?.id ===
                                        collaborationNeed?.node?.id
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">
                                  {collaborationNeed?.node?.title}
                                </p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" md={2} className="mb-2">
                      <p
                        className="mb-0 font-weight-normal"
                        style={{ fontSize: "13px", color: "#495057" }}
                      >
                        ステークホルダー
                      </p>
                    </Col>
                    <Col xs="12" md={10}>
                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {supporterInformation?.data?.allTarget?.edges?.map(
                          (target, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: "6px 17px",
                                  borderRadius: "5px",
                                  backgroundColor:
                                    collaborationNeeds?.data?.myCso?.edges[0]?.node?.csocollaborationneeds?.stakeholders?.edges?.find(
                                      (x) => x?.node?.id === target?.node?.id
                                    )
                                      ? "#44cae1"
                                      : "#c4c4c4",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                              >
                                <p className="m-0">{target?.node?.name}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}
    </CSSTransitionGroup>
  );
};

export default TabCollaborationPolicy;
